import { render, staticRenderFns } from "./Factoring.vue?vue&type=template&id=58bb87cc&scoped=true"
import script from "./Factoring.vue?vue&type=script&lang=js"
export * from "./Factoring.vue?vue&type=script&lang=js"
import style0 from "./Factoring.vue?vue&type=style&index=0&id=58bb87cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb87cc",
  null
  
)

export default component.exports